@use '@css/variables';

.container {
  padding: 20px 30px;

  .card {
    display: flex;
    max-width: 960px;
    flex-direction: column-reverse;
    margin: 0 auto;
    background-color: white;
    border-radius: var(--border-radius);
    overflow: hidden;

    .content {

      padding: 2 * 1.25em;
      h2 {
        margin-bottom: 1.25em;
      }

      a {
        margin-top: 1.25em;
      }
    }

    .images {
      position: relative;
      height: 140px;

      img.background {
        position: absolute;
        top: 0; left: 0;
        width: 100%; height: 100%;
        object-fit: cover;
      }

      img.floating {
        position: absolute;

        height: 200px;
        width: auto;
        right: 20px;
        bottom: -60px;
        //object-fit: contain;
        object-fit: cover;
      }
    }
  }
}


@media only screen and (min-width: variables.$md-breakpoint) {
  .container {
    //background-color: red;

    .card {
      flex-direction: row;

      .content {
        flex-basis: 62%;
      }

      .images {
        flex-basis: 38%;
        position: relative;
        height: auto;

        img.background {
          position: absolute;
          top: 0; left: 0;
          width: 100%; height: 100%;
          object-fit: cover;
        }

        img.floating {
          position: absolute;

          height: 90%;
          width: 90%;
          bottom: 5%;
          object-fit: contain;
        }
      }
    }
  }
}